/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/portfolio-2025.glb --transform -j
Files: public/portfolio-2025.glb [377.76KB] > E:\dev-projects\web-projects\portfolio-2025\portfolio-2025-transformed.glb [52.62KB] (86%)
*/

import * as THREE from 'three'
import { useGLTF, useTexture } from '@react-three/drei'
import Bulletin from './Bulletin.tsx'
import Screen from './Screen.tsx'
import { MathProps, ReactProps, EventHandlers, InstanceProps } from '@react-three/fiber'
import { Mutable, Overwrite } from '@react-three/fiber/dist/declarations/src/core/utils'
import { JSX } from 'react/jsx-runtime'
import Mug from './Mug.tsx'

export function MyScene(
    props: JSX.IntrinsicAttributes &
        Mutable<
            Overwrite<
                Partial<
                    Overwrite<
                        THREE.Group<THREE.Object3DEventMap>,
                        MathProps<THREE.Group<THREE.Object3DEventMap>> &
                            ReactProps<THREE.Group<THREE.Object3DEventMap>> &
                            Partial<EventHandlers>
                    >
                >,
                Omit<
                    InstanceProps<THREE.Group<THREE.Object3DEventMap>, typeof THREE.Group>,
                    'object'
                >
            >
        >
) {
    const { nodes } = useGLTF('./portfolio-2025-transformed.glb')

    // Baked texture
    const bakedTexture = useTexture('./baked.jpg')
    bakedTexture.flipY = false
    const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })

    return (
        <group {...props} dispose={null}>
            <mesh
                geometry={(nodes.desk as THREE.Mesh).geometry}
                material={bakedMaterial}
                position={[-0.493, 0.571, 1.548]}
                rotation={[0, 1.571, 0]}
            />
            <mesh
                geometry={(nodes.keyboard as THREE.Mesh).geometry}
                material={bakedMaterial}
                position={[-0.296, 0.712, 1.387]}
                rotation={[-0.002, 0.183, 0.001]}
            />
            <mesh
                geometry={(nodes.mousepad as THREE.Mesh).geometry}
                material={bakedMaterial}
                position={[-0.493, 0.69, 1.366]}
            />
            <mesh geometry={(nodes.wall as THREE.Mesh).geometry} material={bakedMaterial} />
            <mesh
                geometry={(nodes.mouse as THREE.Mesh).geometry}
                material={bakedMaterial}
                position={[-0.806, 0.691, 1.379]}
                rotation={[0, -0.155, 0]}
            />
            <mesh
                geometry={(nodes.chair as THREE.Mesh).geometry}
                material={bakedMaterial}
                position={[-1.169, 0.235, 0.695]}
                rotation={[0, 1.05, 0]}
            />
            <mesh geometry={(nodes.floor as THREE.Mesh).geometry} material={bakedMaterial} />
            <mesh
                geometry={(nodes.pc as THREE.Mesh).geometry}
                material={bakedMaterial}
                position={[0.485, 0.009, 1.657]}
                rotation={[0, -1.571, 0]}
            />
            <mesh
                geometry={(nodes.plant as THREE.Mesh).geometry}
                material={bakedMaterial}
                position={[-1.629, 0.012, 1.584]}
                rotation={[Math.PI, -0.336, Math.PI]}
            />
            <mesh
                geometry={(nodes.coaster as THREE.Mesh).geometry}
                material={bakedMaterial}
                position={[0.147, 0.688, 1.552]}
            />
            <Bulletin />
            <Screen />
            <Mug />
        </group>
    )
}

useGLTF.preload('./portfolio-2025-transformed.glb')
